export default {
  english: 'English',
  arabic: 'Arabic',
  login: 'Login',
  cart: 'Cart',
  sidebar: {
    dashboard: 'dashboard',
    insurance_policy: 'insurance policy',
    products: 'products',
    orders: 'orders',
    offers: 'offers',
    withdraw: 'withdraw',
    reviews: 'reviews',
    categories: 'categories',
    collection: 'collection',
    processing: 'processing',
    settings: 'settings',
    collections: 'collections'
  }
}
